import {
	Box,
	DialogContent,
	DialogTitle,
	Menu,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableRow,
} from '@mui/material';
import { nanoid } from '@reduxjs/toolkit';
import { FC, SyntheticEvent, useState, useRef, useEffect } from 'react';
import { TPerMsVatValues, TReimbursementList } from 'redux/reducers/reports/types';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';
import { CountryWithFlag } from 'ui/CountryWithFlag';
import { OrderCurrency } from 'ui/OrderCurrency';

export type TAmountSpeedDialProps = {
	perMsVatValues: TReimbursementList[];
};

export const AmountSpeedDial: FC<TAmountSpeedDialProps> = ({ perMsVatValues }) => {
	const anchorVatReportEl = useRef<HTMLDivElement>(null);
	const [open, setOpen] = useState(false);

	const orderCurrency = 'EUR';

	const speedDialTooltipOpen = (e: SyntheticEvent) => {
		e.stopPropagation();
		setOpen(true);
	};
	const speedDialTooltipClose = (e: SyntheticEvent) => {
		e.stopPropagation();
		setOpen(false);
	};

	return (
		<>
			<div
				onClick={speedDialTooltipOpen}
				style={{ position: 'absolute', right: '0', top: '0', width: '100%', height: '100%' }}
				className="action-speed-dial"
				ref={anchorVatReportEl}
			/>
			<Menu
				anchorEl={anchorVatReportEl.current}
				open={open}
				onClose={speedDialTooltipClose}
				sx={{
					'& .MuiPaper-root': {
						width: '300px',
						maxWidth: 'none',
						borderRadius: '12px',
						p: 0,
						m: 0,
					},
					'& .MuiList-root': {
						padding: 0,
						m: 0,
					},
				}}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
			>
				<Box>
					{/* <DialogTitle color="primary" sx={{ p: '10px', fontSize: '1rem' }}>
						Amount breakdown
					</DialogTitle> */}
					<DialogContent sx={{ p: '10px' }}>
						<TableContainer>
							<Table>
								<TableBody>
									{perMsVatValues &&
										perMsVatValues.map((item) => {
											const key = Object.keys(item)[0];
											const val = Object.values(item)[0];
											if (val <= 0) return null;
											return (
												<TableRow key={nanoid()}>
													<TableCell sx={{ padding: '2px', borderBottom: 0 }}>
														<CountryWithFlag countryCode={key} />
													</TableCell>
													<TableCell align="right" sx={{ padding: '2px', borderBottom: 0 }}>
														<AmountAndCurrency amount={val ?? 0} currency={orderCurrency} />
													</TableCell>
												</TableRow>
											);
										})}
								</TableBody>
							</Table>
						</TableContainer>
					</DialogContent>
				</Box>
			</Menu>
		</>
	);
};
